import { Search } from 'components/header/search'
export default Search
